import Avatar from '@mui/material/Avatar';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';
import useAppSelector from 'src/hooks/Redux/useAppSelector';
import { selectCircleDetailsData } from 'src/redux/slices/circleDetailsSlice/circleDetailsSlice';
import styles from './AvatarComponent.module.scss';

interface AvatarComponentProps {
  isLeader: boolean;
}

export const AvatarComponent: React.FC<AvatarComponentProps> = () => {
  const isNarrowMobile = useMediaQuery('(max-width:545px)');
  const circleData = useAppSelector(selectCircleDetailsData);
  const { leader_avatar_url, tribe_avatar_url, tribe_name } = circleData || {};
  const avatarUrl = isNarrowMobile
    ? tribe_avatar_url
    : tribe_avatar_url || leader_avatar_url;
  const avatarSize = isNarrowMobile ? 104 : 240;

  return (
    <div className={styles.avatar}>
      <Avatar
        src={avatarUrl}
        className={styles.circleImage}
        sx={{
          width: avatarSize,
          height: avatarSize,
          borderRadius: '50%',
          background: '#f1f1f1',
          color: '#5b5b66',
          fontSize: isNarrowMobile ? 34 : 48,
          fontWeight: 700,
          '& img': { objectFit: 'cover' },
        }}
      >
        {isNarrowMobile
          ? tribe_name?.trim().charAt(0).toUpperCase() || 'C'
          : null}
      </Avatar>
    </div>
  );
};
